import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { targetStateData } from '@isophi/core-ui';
import { ManagerTarget } from '@isophi/mng-api';

import { supportTypeData } from '../../constants/data';

@Component({
  selector: 'app-pap-plan-row',
  templateUrl: './pap-plan-row.component.html',
  styleUrls: ['./pap-plan-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PapPlanRowComponent {
  @Input() portfolioTarget: ManagerTarget;

  targetStateData = targetStateData;

  supportTypeData = supportTypeData;

  getTargetStateClass(state: string): string {
    switch (state) {
      case 'waiting':
        return 'target-state-waiting';
      case 'in_process':
        return 'target-state-in-process';
      case 'finished':
        return 'target-state-finished';
      case 'incomplete':
        return 'target-state-incomplete';
      default:
        return '';
    }
  }
}
